"use client"

import { Analytics } from "@vercel/analytics/react"
import { useConsent } from "./consent-provider"

export function ConditionalAnalytics() {
    const { preferences, hasConsented } = useConsent()

    // Only load analytics if user has consented AND enabled analytics
    if (!hasConsented || !preferences.analytics) {
        return null
    }

    return <Analytics />
}
